import { assert } from '@/core/assert';
class BufferAttributeAccessor {
    constructor(attr) {
        this.attr = attr;
        this.array = attr.array;
        this.itemSize = attr.itemSize;
        if (attr.isInterleavedBufferAttribute) {
            this.offset = attr.offset;
            this.stride = attr.data.stride;
        }
        else {
            this.offset = 0;
            this.stride = attr.itemSize;
        }
    }
    get count() {
        return this.attr.count;
    }
}
export class BufferAttributeAccessor2 extends BufferAttributeAccessor {
    at(i, target) {
        assert(this.itemSize >= 2, 'Access out of bounds');
        const o = i * this.stride + this.offset;
        target.x = this.array[o];
        target.y = this.array[o + 1];
        return target;
    }
}
export class BufferAttributeAccessor3 extends BufferAttributeAccessor {
    at(i, target) {
        assert(this.itemSize >= 3, 'Access out of bounds');
        const o = i * this.stride + this.offset;
        target.x = this.array[o];
        target.y = this.array[o + 1];
        target.z = this.array[o + 2];
        return target;
    }
}
